/**
 * Pure toggles for the Filters staff / service-type selections, shared by the
 * desktop FilterDropdown and the mobile Filters sheet. "All selected" is the
 * `"all"` sentinel, re-added once every item is on.
 */
export function toggleInSelection(
  selection: string[],
  id: string,
  allIds: string[],
): string[] {
  // "all" may be the bare sentinel (the initial state), so expand it to every
  // id first; otherwise unchecking one item would leave only that item.
  let next = selection.includes("all")
    ? [...allIds]
    : selection.filter((v) => v !== "all");
  if (next.includes(id)) {
    next = next.filter((v) => v !== id);
  } else {
    next = next.concat(id);
  }
  if (allIds.every((sid) => next.includes(sid))) {
    next = ["all", ...allIds];
  }
  return next;
}

/** True when `id` is selected (explicitly or via the "all" sentinel). */
export const isSelected = (selection: string[], id: string): boolean =>
  selection.includes("all") || selection.includes(id);

/**
 * Spell out a bare `["all"]` as `["all", ...allIds]` so toggling one item off
 * leaves the others on.
 */
export const expandAll = (selection: string[], allIds: string[]): string[] =>
  selection.includes("all") ? ["all", ...allIds] : selection;
